// component-add-to-box.js
// <add-to-box> — adds a meal to the client-side box selection, then sends the
// customer to the box page. Wraps one [data-add-to-box] trigger button.
//
//   <add-to-box
//     data-variant-id="123"
//     data-box-key="build-a-box"
//     data-redirect="/collections/build-a-box"
//     data-title="Tofu Masala Curry"
//     data-price="600"
//     data-plant-points="12"
//     data-image="//cdn.../meal.jpg">
//     <button data-add-to-box>Add to box +</button>
//   </add-to-box>
//
// The meal is recorded in window.allplants.box (box-store.js) — a localStorage
// selection, NOT the Shopify cart. Nothing hits the cart until the customer
// presses Checkout on the box page. Because it's client-side, the add is instant
// and works everywhere, including the theme editor.
if (!customElements.get("add-to-box")) {
  customElements.define(
    "add-to-box",
    class AddToBox extends HTMLElement {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector("[data-add-to-box]");
        this.variantId = Number(this.dataset.variantId) || null;
        this.boxKey = this.dataset.boxKey || "build-a-box";
        this.redirect = this.dataset.redirect || "/";
        this.meta = {
          image: this.dataset.image || "",
          title: this.dataset.title || "",
          price: Number(this.dataset.price) || 0,
          points: Number(this.dataset.plantPoints) || 0,
        };
        this.button?.addEventListener("click", this._onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this._onClick);
      }

      _navigate() {
        if (window.Shopify && window.Shopify.designMode) {
          try {
            window.top.location.href = this.redirect;
            return;
          } catch (e) {}
        }
        window.location.href = this.redirect;
      }

      _onClick(event) {
        event.preventDefault();

        const BOX_MAX = 8;
        const box = window.allplants && window.allplants.box;

        if (box && this.variantId) {
          const currentTotal = box.count(this.boxKey);

          if (currentTotal >= BOX_MAX) {
            if (this.button) {
              const original = this.button.textContent;
              this.button.textContent = 'Box is full!';
              this.button.disabled = true;
              setTimeout(() => {
                this.button.textContent = original;
                this.button.disabled = false;
              }, 2000);
            }
            return;
          }

          box.change(this.boxKey, this.variantId, 1, this.meta);
        }

        const currentPath = window.location.pathname.replace(/\/$/, '');
        const redirectPath = this.redirect.split('?')[0].replace(/\/$/, '');
        if (currentPath !== redirectPath) {
          this._navigate();
        } else {
          this.dispatchEvent(new CustomEvent('add-to-box:added', { bubbles: true }));
        }
      }
    }  // closes class AddToBox
  );   // closes customElements.define(
}      // closes if (!customElements.get(...))
